// 事项负责人只是显示标签；不发送账号归属、执行状态或模型配置。
export function buildProjectPlanItem(projectGuid, draft) {
  const title = String(draft.title || '').trim()
  if (!title || title.length > 200) throw new Error('请填写1至200字的事项名称')
  const status = draft.status || 'todo'
  if (!['todo', 'doing', 'done'].includes(status)) throw new Error('事项状态无效')
  const payload = { projectGuid, title, assigneeLabel: String(draft.assigneeLabel || '').trim(),
    dueAt: draft.dueAt ? Math.floor(Number(draft.dueAt) / 1000) : 0, status }
  if (draft.itemGuid) Object.assign(payload, { itemGuid: draft.itemGuid, version: draft.version })
  return payload
}
